<template>
  <div class="s-footer" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
  </div>
</template>

<script>

import SAnimateImage from '../AnimateImage/index.vue'

export default {
  name: 'SVersionFooter',
  components: { SAnimateImage },
  props: {
    defaultBg: {
      type: Object,
      required: true
    },
    request: {
      type: Function
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.s-footer{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
